import { combineReducers } from 'redux';
import Auth from './Auth';
import Theme from './Theme';

const reducers = (firebaseReducer, firestoreReducer) => combineReducers({
    theme: Theme,
    auth: Auth,
    firebase: firebaseReducer,
    firestore: firestoreReducer
});

export default reducers;